<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-toolbar-title class="headline font-weight-bold"
        >Notification</v-toolbar-title
      >
    </v-app-bar>

    <notification-list></notification-list>
  </div>
</template>

<script>
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import NotificationList from '@/components/lists/NotificationList'

export default {
  name: 'NotificationPage',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
    NotificationList
  }
}
</script>
